<h2 mat-dialog-title class="mat-dialog-title">{{'reporttemplateeditDialog.templateSettings' | translate}}</h2>
<mat-dialog-content class="template-dialog-container">
  <mat-sidenav-container class="template-menu-container">
    <mat-sidenav mode="side" opened class="template-menu-sidenav">
      <ng-container *ngFor="let key of propertyPanels">
        <mat-nav-list *ngIf="!isVisol || key !== 'List'" class="template-sidenavi" fxLayout="column" fxLayoutAlign="center center">
          <div class="sidenavi-navigation">
            <div class="sidenavi-itemLink-div">
              <a class="sidenavi-itemLink" [class.inputGroupSelected]="selectedPanelId === key" fxLayout="row"
                (click)="selectPanel(key)">
                <span class="sidenavi-navText">{{ 'objects.' + key| translate }}</span>
              </a>
            </div>
          </div>
        </mat-nav-list>
      </ng-container>
    </mat-sidenav>
    <mat-sidenav-content #sidenavcontent class="template-menu-content">
      <div #templatecontent class="form-container" name="edit" fxLayout="column" fxLayoutAlign="start"
        fxLayoutGap="10px">
        <div class="common-elem-prop-panel">
          <table mat-table [dataSource]="selectedPanel.mapTableData.get()"
            *ngIf="propertyPanelId !== selectedPanelId && reportNamePanelId !== selectedPanelId && listPanelId !== selectedPanelId">
            <ng-container matColumnDef="propertyValue">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let metadata">
                <app-property-editor [propId]="selectedPanel.propId" [metadata]="metadata" [isCommon]="true"
                  (changeValue)="onCommPropChange($event)"></app-property-editor>
              </td>
            </ng-container>
            <!-- Table Row -->
            <tr mat-header-row *matHeaderRowDef="propertyTableColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: propertyTableColumns;"></tr>
          </table>
          <div class="template-property-div" *ngIf="reportNamePanelId === selectedPanelId && !isVisol" fxLayout="column"
            fxLayoutGap="20px">
            <mat-form-field>
              <mat-label> {{'reporttemplateeditDialog.formatMode' | translate}} </mat-label>
              <mat-select [formControl]="formatModeControl"
                (selectionChange)="onChangeAtTemplateFormatMode()">
                <mat-option [value]="formatMode.value" *ngFor="let formatMode of formatModes">
                  {{ formatMode.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="formatModeControl && formatModeControl.value !== '0'">
              <p class="name-format-title">
                {{'reporttemplateeditDialog.nameFormat' | translate}}</p>
              <div class="format-button-div">
                <button mat-button color="primary" (click)="openEditFormatDialog(false)">
                  <mat-icon aria-label="">add_box</mat-icon>{{'reporttemplateeditDialog.add' | translate}}
                </button>
                <button mat-button color="primary" (click)="openEditFormatDialog(true)"
                  [disabled]="isDisableEditButton()">
                  <mat-icon aria-label="">edit</mat-icon>{{'reporttemplateeditDialog.edit' | translate}}
                </button>
                <button mat-button color="primary" (click)="moveLeftTitleFormatItem()"
                  [disabled]="isDisableMoveLeftButton()">
                  <mat-icon aria-label="">arrow_back</mat-icon>{{'reporttemplateeditDialog.moveLeft' | translate}}
                </button>
                <button mat-button color="primary" (click)="moveRightTitleFormatItem()"
                  [disabled]="isDisableMoveRightButton()">
                  <mat-icon aria-label="">arrow_forward</mat-icon>{{'reporttemplateeditDialog.moveRight' | translate}}
                </button>
                <button mat-button color="warn" (click)="deleteReportName()" [disabled]="isDisableDeleteButton()">
                  <mat-icon aria-label="">delete</mat-icon>{{'reporttemplateeditDialog.delete' | translate}}
                </button>
              </div>
              <div fxLayout="row wrap" fxLayoutGap="20px">
                <ng-container *ngFor="let title of titleFormat; index as i">
                  <div class="format-value-div" (click)="selectTitleFormat(i)"
                    [ngClass]="{'selected': i === selectedTitleFormat}">
                    {{ title.type === 'dynamic'? ('objects.' + title.value | translate) : title.value }}
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="template-property-div" *ngIf="reportNamePanelId === selectedPanelId && isVisol" fxLayout="column"
            fxLayoutGap="20px">
            <p class="name-format-title">
              {{'reporttemplateeditDialog.nameFormat' | translate}} : {{this.formatModes[this.data.templateReportTitleInputMode].label}}</p>
          </div>
          <div class="template-property-div">
            <mat-form-field *ngIf="propertyPanelId === selectedPanelId">
              <mat-label> {{'reporttemplateeditDialog.templateName' | translate}}</mat-label>
              <input matInput maxlength="{{templateNameLength}}"
                [formControl]="templateNameForm" required (change)="onChangeAtTemplateName()">
              <mat-hint align="end">{{templateNameForm.value?.length || 0}}/{{templateNameLength}}</mat-hint>
              <mat-error *ngIf="templateNameForm.hasError('required')">
                {{'reporttemplateeditDialog.templatenameRequired' | translate}}
              </mat-error>
              <mat-error *ngIf="templateNameForm.hasError('maxlength')">{{'reporttemplateeditDialog.enterCharacters' | translate: {templateNameLength:templateNameLength} }}
              </mat-error>
              <mat-error *ngIf="templateNameForm.hasError('pattern') && !templateNameForm.hasError('required')">{{'reporttemplateeditDialog.entervalidName' | translate}}</mat-error>
            </mat-form-field>
            <div fxLayout="row" fxLayoutAlign="start"
              [style.visibility]="propertyPanelId === selectedPanelId ? 'visible' : 'hidden'">
              <mat-slide-toggle color="primary" (change)="onChangeAtTemplateIsValid()">
                <div *ngIf="toggle.checked"> {{'reporttemplateeditDialog.enabled' | translate}} </div>
                <div *ngIf="!toggle.checked"> {{'reporttemplateeditDialog.disabled' | translate}} </div>
              </mat-slide-toggle>
            </div>
          </div>
          <div class="template-property-div" *ngIf="listPanelId === selectedPanelId" fxLayout="column"
          fxLayoutGap="20px">
          <p class="name-format-title">{{'reporttemplateeditDialog.listDetails' | translate}}</p>
            <table class="observation-table" *ngIf="ListsFormat.length > 0">
              <tr>
                <th>{{'reporttemplateeditDialog.name' | translate}}</th>
                <th>{{'reporttemplateeditDialog.count' | translate}}</th>
                <th>{{'reporttemplateeditDialog.action' | translate}}</th>
              </tr>
              <tr *ngFor="let res of ListsFormat; index as i">
                <td>{{res.name}}</td>
                <td>{{res.listData.length}}</td>
                <td>
                  <button mat-icon-button [matTooltip]="'reporttemplateeditDialog.edit' | translate" color="primary" (click)="openListDialog(true, res, i)">
                    <mat-icon aria-label="">edit</mat-icon>
                  </button>
                  <button mat-icon-button [matTooltip]="'reporttemplateeditDialog.delete' | translate" color="warn" (click)="deleteList(i)">
                    <mat-icon aria-label="">delete</mat-icon>
                  </button>
                </td>
              </tr>
            </table>
            <div class="format-button-div">
              <button mat-button color="primary" (click)="openListDialog(false)">
                <mat-icon aria-label="">add_box</mat-icon>{{'reporttemplateeditDialog.addnewList' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</mat-dialog-content>
<div fxLayout="row wrap" fxLayoutAlign="center">
  <mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">{{'reporttemplateeditDialog.close' | translate}}</button>
  </mat-dialog-actions>
</div>
